import React from 'react';
import { motion } from 'framer-motion';

function WhatWeInvestIn() {
  const sectors = [
    {
      key: 'healthcare',
      title: "Healthcare",
      description: "Investing in MedTech, pharmaceuticals, life sciences, diagnostics, and healthcare IT to improve effectiveness, efficiency, and accessibility.",
      image: "/images/medicine-8287535_640.jpg"
    },
    {
      key: 'digital',
      title: "Digital Assets",
      description: "Focus on cryptocurrency, blockchain infrastructure, decentralized finance, and digital asset investment opportunities.",
      image: "/images/about-us/cryptocurrency-3423267_640.jpg"
    },
    {
      key: 'agriculture',
      title: "Agriculture",
      description: "Supporting sustainable food production, agri-tech innovation, and food security solutions for growing populations.",
      image: "/images/agriculture/wheat-9666681_1280.jpg"
    },
    {
      key: 'real-estate',
      title: "Real Estate",
      description: "Commercial properties, residential developments, REITs, and real estate technology platforms creating value in the built environment.",
      image: "/images/real-estate/real-estate-6846366_640.jpg"
    },
    {
      key: 'technology',
      title: "Technology",
      description: "Software, digital media & entertainment, consumer internet, and AI-driven innovation opportunities.",
      image: "/images/technology/engineer-4904884_1280.jpg"
    },
    {
      key: 'industrial',
      title: "Industrial Technology",
      description: "Digitalization and sustainability solutions including automation, IoT, sustainability tech, and industrial innovation.",
      image: "/images/industrial-tech/loader-1846346_1280.jpg"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div
          data-aos="fade-up"
          data-aos-delay="100"
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-semibold text-gray-900 mb-4">What We Invest In</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto text-center">
            Diverse investment opportunities across key sectors driving economic growth and innovation
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sectors.map((sector, index) => (
            <div
              key={sector.key}
              data-aos="fade-up"
              data-aos-delay={`${200 + index * 100}`}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-500 hover:scale-105"
            >
              <img 
                src={sector.image}
                alt={sector.title}
                className="w-full h-48 object-cover transition-transform duration-500 hover:scale-110"
              />
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">{sector.title}</h3>
                <p className="text-gray-600 leading-relaxed">{sector.description}</p>
                <div className="mt-5">
                  <a href={`/investments/${sector.key === 'digital' ? 'digital-assets' : sector.key === 'industrial' ? 'industrial-technology' : sector.key}`} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] text-black font-medium">
                    Learn more
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhatWeInvestIn;

